import { Temporal } from "@js-temporal/polyfill";

export function today(timezone = "America/Vancouver"): string {
  return Temporal.Now.zonedDateTimeISO(timezone).toPlainDate().toString();
}

export function addDays(date: string, days: number): string {
  return Temporal.PlainDate.from(date).add({ days }).toString();
}

export function endOfMonth(date: string): string {
  const value = Temporal.PlainDate.from(date);
  return value.with({ day: value.daysInMonth }).toString();
}

export function humanDate(date: string): string {
  const value = Temporal.PlainDate.from(date);
  return new Intl.DateTimeFormat("en-CA", { month: "short", day: "numeric", timeZone: "UTC" }).format(new Date(`${value.toString()}T12:00:00Z`));
}
